import { render } from "./ChallengeView.vue?vue&type=template&id=045900c2&ts=true"
import script from "./ChallengeView.vue?vue&type=script&lang=ts"
export * from "./ChallengeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__